module.exports = __webpack_public_path__ + "img/NewAvantLogo.93c21605.png";